import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import JournalApp from "./journal/JournalApp";

const path = window.location.pathname;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {path.startsWith("/journal") ? <JournalApp /> : <App />}
  </React.StrictMode>
);
